/**
 * helixsnapshotreducer.js
 * Created by yonamine on 07/07/2021.
 */
import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';

const reducerViewKey = 'helix-snapshots-documents';

export default function helixsnapshotreducer(state = initialstate.helixSnapshot, action) {
	let bodyId, documentId;

	switch (action.type) {
		case actions.SIMPLE_HELIX_BOUNDING_BOXES_SHOW: {
			return {
				...state,
				[action.bodyId]: {
					...state[action.bodyId],
					showBoundingBoxes: action.show
				}
			};
		}
		case actions.SET_SIMPLE_HELIX_LOADING_STATE: {
			return {
				...state,
				[action.bodyId]: {
					...state[action.bodyId],
					[action.stateKey]: action.isLoading
				}
			};
		}
		case actions.GET_ALL_SIMPLE_HELIX_DOCUMENTS:
			{
				if (action.response && !action.error) {
					return applyHelixDocuments(state, action);
				}
			}
			break;
		case actions.GET_SIMPLE_HELIX_DOCUMENT_BLOB: {
			if (action.response && !action.error) {
				bodyId = action.bodyId;
				documentId = action.documentId;

				const screenshotDocument = {
					...state[bodyId].helixDocuments.byId[documentId],
					base64Image: `data:image/png;base64,${action.response}`
				};

				return {
					...state,
					[bodyId]: {
						...state[bodyId],
						helixDocuments: {
							...state[bodyId].helixDocuments,
							byId: {...state[bodyId].helixDocuments.byId, [documentId]: screenshotDocument}
						}
					}
				};
			}
			break;
		}
		case actions.GET_CAPTURE_ANNOTATIONS:
			{
				if (action.response && !action.error) {
					return applyAnnotations(state, action);
				}
			}
			break;
		case actions.UPLOAD_CAPTURE_IMAGE:
			{
				let {bodyId: key, documentId} = action.payload;
				let newDocument = {
					...state[key].helixDocuments.byId[documentId],
					...action.payload,
					id: documentId
				};

				const newHelixDocuments = Utility.safeNormalize(newDocument, state[key]?.helixDocuments, undefined, true);

				state = {
					...state,
					[key]: {
						...state[key],
						helixDocuments: newHelixDocuments
					}
				};
			}
			break;
		case actions.COMPLETE_CAPTURE_IMAGE_UPLOAD:
			{
				let payload = action.payload;

				let newDocument = {
					...state[payload.bodyId].helixDocuments.byId[payload.documentId],
					...action.response
				};

				newDocument.documentName = payload.documentName;
				newDocument.fileExt = payload.fileExt;

				const newHelixDocuments = Utility.safeNormalize(newDocument, state[payload.bodyId].helixDocuments, 'id', true);

				state = {
					...state,
					[payload.bodyId]: {
						...state[payload.bodyId],
						helixDocuments: newHelixDocuments,
						uploadedDocumentId: payload.documentId
					}
				};
			}
			break;
		case actions.CLEAR_UPLOADED_SCREENSHOT_DOCUMENT_ID:
			{
				bodyId = action.bodyId;
				state = {
					...state,
					[bodyId]: {
						...state[bodyId],
						uploadedDocumentId: undefined
					}
				};
			}
			break;
		case actions.SET_ANNOTATION_MODE:
			{
				const {bodyId: key, edit} = action;

				state = {
					...state,
					[key]: {
						...state[key],
						helixBodyConfig: edit
					}
				};
			}
			break;
		case actions.ADD_CAPTURE_ANNOTATION: {
			if (!action.error && action.response) {
				const {bodyId: key, documentId} = action;

				// First, we create the new annotation object.
				const annotationAttribute =
					action.response.annotationAttribute !== '' ? JSON.parse(action.response.annotationAttribute) : {};

				const newAnnotation = {
					...annotationAttribute,
					data: {
						createDate: action.response.createDate,
						createUserId: action.response.createUserId,
						createUserName: action.response.createUserName,
						editable: action.response.editable,
						engagementId: action.response.engagementId,
						id: action.response.id,
						modifiedDate: action.response.modifiedDate,
						referenceNumber: action.response.referenceNumber,
						statusChangeDate: action.response.statusChangeDate,
						statusChangeUserID: action.response.statusChangeUserID,
						statusChangeUserName: action.response.statusChangeUserName,
						statusId: action.response.statusId,
						text: action.response.text
					},
					id: action.response.id
				};

				// Then, we add the annotation object to an object with shallow copies of the annotations' object properties.
				const stateAnnotations = Utility.safeNormalize(newAnnotation, state[key].annotations, 'id', true);

				// We now create a new document object, with an updated array of annotation Ids.
				const updatedDocument = {
					...state[key].helixDocuments.byId[documentId],
					annotations: state[key].helixDocuments.byId[documentId].annotations.concat(newAnnotation.id),
					engagementCommentCount: (state[key].helixDocuments.byId[documentId].engagementCommentCount || 0) + 1
				};

				// After that, we assign an updated value of the store to the state variable.
				state = {
					...state,
					[key]: {
						...state[key],
						annotations: stateAnnotations,
						newAnnotation: {
							boundingBox: {}
						}
					}
				};

				// And we modify the documents sub splice to replace the old document data with the new one.
				state[key].helixDocuments = {
					...state[key].helixDocuments,
					byId: {...state[key].helixDocuments.byId, [documentId]: updatedDocument}
				};
			}
			return state;
		}

		//<Notes>
		case actions.GET_ALL_SIMPLE_HELIX_NOTES:
			{
				if (action.response && !action.error) {
					return applyHelixNotes(state, action);
				}
			}
			break;
		case actions.REMOVE_NEW_ANNOTATION:
			{
				state = {
					...state,
					[action.bodyId]: {
						...state[action.bodyId],
						newAnnotation: {
							referenceNumber: 0,
							text: '',
							boundingBox: {}
						}
					}
				};
			}
			break;
		case actions.NEW_ANNOTATION_SAVE:
			{
				if (!action.annotation.boundingBox) {
					action.annotation.boundingBox = {};
				}

				state = {
					...state,
					[action.bodyId]: {
						...state[action.bodyId],
						newAnnotation: action.annotation,
						isEditing: action.isEditing
					}
				};
			}
			break;
		case actions.ADD_BOUNDINGBOX_ANNOTATION: {
			if (!action.error) {
				state = {
					...state,
					[action.bodyId]: {
						...state[action.bodyId],
						isEditing: 0,
						annotations: {
							...state[action.bodyId].annotations,
							byId: {
								...state[action.bodyId].annotations.byId,
								[action.annotationId]: {
									...state[action.bodyId].annotations.byId[action.annotationId],
									selection: action.boundingBoxData.selection,
									geometry: action.boundingBoxData.geometry
								}
							}
						}
					}
				};
			}
		}

		case actions.SET_NEW_ANNOTATION_BOUNDING_BOX:
			{
				state = {
					...state,
					[action.bodyId]: {
						...state[action.bodyId],
						newAnnotation: {
							...state[action.bodyId].newAnnotation,
							boundingBox: action.boundingBox
						}
					}
				};
			}
			break;
		case actions.SET_REFERENCE_NUMBER_NEW_ANNOTATION: {
			state = {
				...state,
				[action.bodyId]: {
					...state[action.bodyId],
					newAnnotation: {
						...state[action.bodyId].newAnnotation,
						referenceNumber: action.referenceNumber
					}
				}
			};
			break;
		}
		case actions.EDIT_ANNOTATION: {
			if (!action.error) {
				state = {
					...state,
					[action.bodyId]: {
						...state[action.bodyId],
						annotations: {
							...state[action.bodyId].annotations,
							byId: {
								...state[action.bodyId].annotations.byId,
								[action.annotationId]: {
									...state[action.bodyId].annotations.byId[action.annotationId],
									data: {
										...state[action.bodyId].annotations.byId[action.annotationId].data,
										text: action.text,
										referenceNumber: action.referenceNumber
									}
								}
							}
						}
					}
				};
			}
			break;
		}
		case actions.EDIT_BOUNDINGBOX: {
			if (!action.error) {
				state = {
					...state,
					[action.bodyId]: {
						...state[action.bodyId],
						annotations: {
							...state[action.bodyId].annotations,
							byId: {
								...state[action.bodyId].annotations.byId,
								[action.annotationId]: {
									...state[action.bodyId].annotations.byId[action.annotationId],
									geometry: action.annotationAttribute && annotationAttribute.geometry,
									selection: action.annotationAttribute && annotationAttribute.selection
								}
							}
						}
					}
				};
			}
			break;
		}
		case actions.CANCEL_BOUNDING_BOX: {
			const {bodyId} = action;
			return {
				...state,
				[bodyId]: {
					...state[bodyId],
					isEditing: 0,
					helixDocuments: {
						...state[bodyId].helixDocuments,
						newAnnotation: {}
					}
				}
			};
		}
		case actions.UPDATE_DOCUMENT: {
			const {entityUId: bodyId, viewKey, documentId} = action;

			if (viewKey === reducerViewKey && action && !action.error) {
				return {
					...state,
					[bodyId]: {
						...state[bodyId],
						helixDocuments: {
							...state[bodyId].helixDocuments,
							byId: {
								...state[bodyId].helixDocuments.byId,
								[documentId]: {...state[bodyId].helixDocuments.byId[documentId], ...action.meta.api.data}
							}
						}
					}
				};
			}
			return state;
		}
		default:
			break;
	}
	return state;
}

function applyHelixDocuments(state, action) {
	let key = action.key;

	state = {
		...state,
		[key]: {
			helixDocuments: Utility.normalize(),
			annotations: Utility.normalize()
		}
	};

	for (let data of action.response.data) {
		let screenshotDataItem = {
			id: data.id,
			engagementCommentCount: data.engagementCommentCount,
			createDate: data.createDate,
			modifiedDate: data.modifiedDate,
			documentName: data.documentName,
			annotations: [],
			versionNumber: data.versionNumber || 1,
			fileExt: data.fileExt
		};

		state[key].helixDocuments = Utility.normalize(screenshotDataItem, state[key].helixDocuments);
		state[key].newAnnotation = {
			referenceNumber: 0,
			text: '',
			boundingBox: {}
		};
	}

	return state;
}

function applyHelixNotes(state, action) {
	let key = action.key;

	state = {
		...state,
		[key]: {
			helixNotes: undefined
		}
	};

	for (let i = 0; i < action.response.data.length; i++) {
		let data = action.response.data[i];
		let noteDataItem = {
			id: data.id
		};

		state[key].helixNotes = Utility.normalize(noteDataItem, state[key].helixNotes);
	}

	return state;
}

function applyAnnotations(state, {bodyId: key, response, documentId}) {
	const annotations = response.annotations.map((a) => {
		const attribute = a.annotationAttribute !== '' ? JSON.parse(a.annotationAttribute) : {};

		return {
			data: {
				createDate: a.createDate,
				createUserId: a.createUserId,
				createUserName: a.createUserName,
				editable: a.editable,
				engagementId: a.engagementId,
				id: a.id,
				modifiedDate: a.modifiedDate,
				referenceNumber: a.referenceNumber,
				statusChangeDate: a.statusChangeDate,
				statusChangeUserID: a.statusChangeUserID,
				statusChangeUserName: a.statusChangeUserName,
				statusId: a.statusId,
				text: a.text
			},
			...attribute,
			id: a.id
		};
	});

	const updatedDocument = {
		...state[key].helixDocuments.byId[documentId],
		annotations: annotations.map((annotation) => annotation.id)
	};
	const newAnnotations = Utility.safeNormalize(annotations, state[key].annotations, 'id', true);

	state = {
		...state,
		[key]: {
			...state[key],
			annotations: newAnnotations,
			helixDocuments: {
				...state[key].helixDocuments,
				byId: {...state[key].helixDocuments.byId, [documentId]: updatedDocument}
			}
		}
	};

	return state;
}
